// extracted by mini-css-extract-plugin
export default {"root":"ClientPanel_root__Su5AX","content":"ClientPanel_content__kWA-Y"};